import script from "./UploadModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadModal.vue?vue&type=script&setup=true&lang=js"

import "./UploadModal.vue?vue&type=style&index=0&id=689967e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-689967e4"]])

export default __exports__